import { apiDelete, apiGet, apiPost, apiPut } from './api';

export type DocumentRow = {
  _id: string;
  title?: string;
  code?: string;
  description?: string;
  docType?: string;
  docDomain?: string;
  status?: string;
  sharingRule?: string;
  currentVersion?: number;
  publishedVersion?: number | null;
  author?: { email?: string; nickname?: string };
  edition?: { lastModified?: string; version?: string };
  updatedAt?: string;
};

export async function getDocumentDraft(id: string) {
  return apiGet<{ success: boolean; data?: { document?: DocumentRow }; message?: string }>(
    `/api/v1/doc/${id}/draft`
  );
}

export async function listDocuments(params: Record<string, string | number> = {}) {
  const qs = new URLSearchParams(
    Object.entries(params).map(([k, v]) => [k, String(v)])
  ).toString();
  return apiGet<{ success: boolean; data?: { documents: DocumentRow[] }; message?: string }>(
    `/api/v1/doc?${qs}`
  );
}

export async function createDocument(body: Record<string, unknown>) {
  return apiPost('/api/v1/doc', body);
}

export async function updateDocument(id: string, body: Record<string, unknown>) {
  return apiPut(`/api/v1/doc/${id}`, body);
}

export async function deleteDocument(id: string) {
  return apiDelete(`/api/v1/doc/${id}`);
}

export async function duplicateDocument(id: string, body: Record<string, unknown> = {}) {
  return apiPost(`/api/v1/doc/${id}/duplicate`, body);
}
